<div class="flex-control flex-column programs-module">
  <app-tabs>
    <li (click)="tabsService.deactivate_tab()" [class.active]="!tabsService.is_active()">Intake Forms</li>
  </app-tabs>
  <app-patient-intake-forms class="flex-control flex-column" [hidden]="tabsService.is_active()"></app-patient-intake-forms>
</div>


